import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-ussdSession-lookup',
  templateUrl: './micro-ussdSession-lookup.component.html'
})
export class MicroUssdSessionLookupComponent  {

  @Input()
  ussdSessionId:any;
}
